import { Component, OnInit, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { CommonService } from "src/app/core/services/common.service";
import { BdspInsertionOrderService } from "src/app/core/services/bdsp/bdsp-insertion-order.service";
import { BdspLineItemService } from "src/app/core/services/bdsp/bdsp-line-item.service";
import { BdspTargeting } from "src/app/models/bdsp/bdsp-line-item";
import { PermissionService } from "src/app/core/services/permisson.service";

@Component({
  selector: "app-entity-bulk-edit",
  templateUrl: "./entity-bulk-edit.component.html",
  styleUrls: ["./entity-bulk-edit.component.scss"],
})
export class EntityBulkEditComponent implements OnInit {
  selectedFields: Array<any> = [];
  fields: Array<any> = [];

  itemsRunning: Array<any> = [];
  isSameBudgetType: boolean = true;
  showSelectedItem: boolean = false;

  isItemRunning: boolean = false;
  isAllDailyPacing: boolean = false;
  isPacingAvailable: boolean = false;
  areDiffActions: Object = {
    country: false,
    zip: false,
    operating: false,
    ads_txt: false,
    audio_start_delay: false,
    player_size: false,
    start_delay: false,
    video_placement_type: false,
    playback_method: false,
    native_layout: false,
    interstitial: false
  };

  clientCurrency: string = "";
  clientTimeZone: string = "";
  selectedDSP: string = 'tdsp';
  dspType: string;
  bdspTargeting: BdspTargeting;
  adspEnabled: boolean = false;
  bdspEnabled: boolean = false;
  tdspEnabled: boolean = false;
  isAdspUS: boolean = false;
  isAdspEU: boolean = false;
  isEveryLiEnded: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private commonService: CommonService,
    public dialogRef: MatDialogRef<EntityBulkEditComponent>,
    private bdspInsertionOrderService: BdspInsertionOrderService,
    private bdspLineItemService: BdspLineItemService,
    private permissionService: PermissionService
  ) {
    this.bdspTargeting = new BdspTargeting();
  }

  ngOnInit(): void {
    if (this.data.type == "line_item") {
      this.getAllLIData();
    } else if (this.data.type == "insertion_order") {
      this.isAllDailyPacing = true;
      this.getAllIOData();
    } else if (this.data.type == "dlv_mod") {
      this.selectedFields = this.data.selectedTrgts;
      this.fields = this.data.fields;
    } else if (this.data.type == "cloneAdv") {
      if (this.data.source == 'tdsp') {
        this.selectedDSP = 'bdsp';
      }
      this.getConfig();
    }
  }

  checkIfEverySelectedLiExpired() {
    const items = this.data?.selectedItems ?? [];
    const allEnded = items.length > 0 && items.every(i => i?.is_ended === true);

    this.isEveryLiEnded = allEnded;

    if (!allEnded) return;

    const endDateSelected = this.selectedFields.includes('end_date');

    this.fields.forEach(field => {
      if (endDateSelected) {
        field.disable = field.key === 'start_date';
      } else {
        field.disable = field.key !== 'end_date';
      }
    });
  }

  getConfig() {
    this.permissionService.getConfig(this.data.agencyId, 'agency').subscribe(res => {
      this.adspEnabled = res.data.adsp_enabled;
      this.bdspEnabled = res.data.bdsp_enabled;
      this.tdspEnabled = res.data.tdsp_enabled;
      this.isAdspUS = res.data.adsp_regions.filter(region => region == 'US');
      this.isAdspEU = res.data.adsp_regions.filter(region => region == 'EU');
    })
  }

  checkAndFilter = (type: string, key: string, columnName: string) => {
    if (!this.isSameAction(type, key)) {
      this.areDiffActions[key.split("_")[0]] = true;
      this.fields.map((field) => {
        if (field["key"] == columnName) {
          field.disable = true;
        }
      });
    }
  };

  isSameAction(type: string, key: string) {
    let commonAction: boolean = true;
    let incItems: Array<any> = [];
    let excItems: Array<any> = [];
    const splitKey = key.split("_action")[0];

    incItems = this.data.selectedItems.filter(
      (item) => item.targeting[type]?.[key] == "include"
    );
    excItems = this.data.selectedItems.filter(
      (item) => item.targeting[type]?.[key] == "exclude"
    );

    if (key === "interstitial_type_action") {
      // for interstitial_type_action check for nulls
      // also make sure it doesn't contain both inc and exc
      const hasNull = this.data.selectedItems.some(
        (item) => item.targeting[type]?.[key] == null
      );
      if (hasNull) return false;
      if (incItems.length > 0 && excItems.length > 0) {
        return false;
      }
    }

    if (incItems.length > 0 && excItems.length > 0) {
      if (
        !incItems.every(
          (item) => item.targeting[type]?.[splitKey].length == 0
        ) &&
        !excItems.every((item) => item.targeting[type]?.[splitKey].length == 0)
      ) {
        commonAction = false;
      }
    }
    return commonAction;
  }

  checkEntityStartStatus() {
    this.isItemRunning = this.data.selectedItems.some(
      ({ is_started }) => is_started
    );
    if (this.isItemRunning) {
      this.fields.forEach((ele) => {
        if (ele.key == "start_date") {
          ele.disable = true;
        }
      });
    }
  }

  checkDailyBudgetAvailability() {
    this.isAllDailyPacing = this.data.selectedItems.every(
      ({ bidding }) =>
        bidding.pacing == "daily_ahead" || bidding.pacing == "daily_even"
    );

    if (!this.isAllDailyPacing) {
      this.fields.forEach((ele) => {
        if (ele.key == "daily_budget") {
          ele.disable = true;
        }
      });
    }

    this.isPacingAvailable =
      this.fields.filter((ele) => ele.key == "daily_budget").length == 1;
  }

  checkBudgetType() {
    this.isSameBudgetType = this.data.selectedItems.every(
      ({ budget }) => budget.type === this.data.selectedItems[0].budget.type
    );
    if (!this.isSameBudgetType) {
      this.fields.forEach((ele) => {
        if (ele.key == "budget") {
          ele.disable = true;
        }
      });
    }
  }

  getAllLIData() {
    this.bdspLineItemService
      .list({
        ...this.data.globalParams,
        search_term: this.data.selectedItems.map((ele) => ele.id).join(","),
        bulk_edit: true,
      })
      .subscribe(
        (res) => {
          this.dspType = 'bdsp';
          this.clientCurrency = res.currency;
          this.clientTimeZone = res.timezone;
          this.fields = [
            ...res.bulk_edit_config.bulk_editable_basic,
            ...res.bulk_edit_config.bulk_editable_creatives,
            ...res.bulk_edit_config.bulk_editable_events,
            ...res.bulk_edit_config.bulk_editable_targeting,
          ];
          this.data.selectedItems = res.data;
          this.showSelectedItem = true;
        },
        (err) => {},
        () => {
          for (const [path, subPath] of Object.entries(this.bdspTargeting)) {
            for (const [key] of Object.entries(subPath)) {
              if (!key.endsWith("_action")) continue;

              const baseProp = key.replace("_action", "");

              if (path == "geo") {
                this.checkAndFilter(path, key, path);
              } else {
                this.checkAndFilter(path, key, baseProp);
              }
            }
          }
          this.checkEntityStartStatus();
          this.checkIfEverySelectedLiExpired();
          this.checkDailyBudgetAvailability();
        }
      );
  }

  getAllIOData() {
    this.bdspInsertionOrderService
      .list({
        ...this.data.globalParams,
        search_term: this.data.selectedItems.map((ele) => ele.id).join(","),
        bulk_edit: true,
      })
      .subscribe(
        (res) => {
          this.dspType = 'bdsp';
          this.clientCurrency = res.currency;
          this.clientTimeZone = res.timezone;
          this.fields = res.bulk_editable_fields;
          this.data.selectedItems = res.data;
          this.showSelectedItem = true;
        },
        (err) => {},
        () => {
          this.checkEntityStartStatus();
          this.checkBudgetType();
        }
      );
  }

  validate() {
    this.itemsRunning.length = 0;

    this.data.selectedItems.forEach((item) => {
      if (item.is_io_started && this.selectedFields.includes("start_date")) {
        this.itemsRunning.push(item);
      }
    });

    this.checkIfEverySelectedLiExpired();
  }

  proceed() {
    if (this.itemsRunning.length == 0) {
      !this.isSameBudgetType && this.selectedFields.includes("budget")
        ? ""
        : this.closeModal(true);
    }
  }

  closeModal(save: boolean = false) {
    if (this.data.type != "dlv_mod" && this.data.type != "cloneAdv")
      this.commonService.setSelectedBulkEditFields(this.selectedFields);
    this.dialogRef.close({
      save: save,
      selectedItems:
        this.data.type == "cloneAdv"
          ? this.selectedDSP
          : this.data.type != "dlv_mod"
          ? this.data.selectedItems.map((ele) => ele.id).join(",")
          : this.selectedFields,
    });
  }
}
